export default {"src":"/_next/static/media/plus.df36e1df.svg","height":25,"width":25};